import {useEffect, useState} from 'react';
import JSZip from 'jszip';

import {getKmzUrl} from '../modules/url';

type LookAtPosition = {
  lati: number;
  long: number;
  height: number;
} | null;

export function useKmzLookAt(kmzId: number | null): LookAtPosition {
  const [position, setPosition] = useState<LookAtPosition>(null);


  useEffect(() => {
    if (!kmzId) return;
    const fetchLookAt = async () => {
      try {
        const url = getKmzUrl(kmzId);
        const response = await fetch(url, {
          credentials: 'include', // <-- sends cookies
        });
        const blob = await response.blob();
        const zip = await JSZip.loadAsync(blob);

        const kmlFile = zip.file(/\.kml$/i)?.[0];
        if (!kmlFile) return;

        const kmlText = await kmlFile.async("text");
        const parser = new DOMParser();
        const xml = parser.parseFromString(kmlText, "application/xml");

        const lookAt = xml.querySelector("LookAt");
        if (!lookAt) return;
        const get = (tag: string) =>
          parseFloat(lookAt.querySelector(tag)?.textContent ?? 'NaN');

        const lati = get("latitude");
        const long = get("longitude");
        const height = get("range");

        if (!Number.isNaN(lati) && !Number.isNaN(long) && !Number.isNaN(height)) {
          setPosition({lati, long, height});
        }
      } catch (err) {
        console.error("Failed to extract LookAt from KMZ:", err);
      }
    };

    fetchLookAt();
  }, [kmzId]);

  return position;
}
